import React from 'react'
import Blogtags from './blogtags'
import Blogscatogries from './blogscatogries'
import Blogsrecents from './blogsrecents'
import Sideblogs from './sideblogs'

const Blogsidesection = () => {
  return (
    <div>
       <div className="columns search_column">
        <div className="search">
          <form>
            <input type="text" name="search" placeholder="Search..." required=""/>
            <button type="submit" className="searchbtn"><i className="fa fa-search" ></i>
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                <path d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
               </svg>
              </button>
          </form>
        </div>
      </div>
      <Blogscatogries/>
      <Sideblogs/>
      {/* <Blogsrecents/> */}
       <Blogtags/>
    </div>
  )
}

export default Blogsidesection